// = Libs =
import { FC, useEffect, useState } from 'react';

// = Containers & Components =
import { deleteQuestion, QuestionModel } from '@/services/question.service';
import classes from './question.module.scss';
import Select from '@/common/components/ui/select/select';
import { OptionModel } from '@/common/components/ui/select/select.types';
import Input from '@/common/components/ui/input/input';
import IconButton from '@/common/components/ui/buttons/icon-button/icon-button';
import Button from '@/common/components/ui/buttons/button/button';

const options = [
  {
    label: 'Открытый вопрос',
    value: 'string',
  },
  {
    label: 'Вопрос с числовым ответом',
    value: 'int',
  },
  {
    label: 'Закрытый вопрос с одним вариантом ответа',
    value: 'radio',
  },

  {
    label: 'Закрытый вопрос с несколькими вариантов ответа',
    value: 'checkbox',
  },
  {
    label: 'Загрузка файла',
    value: 'file',
  },
];

function getOption(type: string) {
  return options.find((o) => {
    return o.value === type;
  });
}

const ChoiceController: FC<{
  value: string[];
  onChange: (newValue: string[]) => any;
}> = (props) => {
  const [val, setVal] = useState(props.value);

  useEffect(() => {
    onChange(val);
  }, [val]);

  const { onChange } = props;
  return (
    <div className={classes['option-container']}>
      <p>Варианты ответа</p>
      {val?.map((v, index) => (
        <div className={classes['option']} key={`option-${index}`}>
          {val.length > 1 && (
            <IconButton
              iconType={'delete'}
              color={'secondary'}
              disabled={false}
              onClick={() => {
                let newVal = [...val];
                newVal.splice(index, 1);
                setVal(newVal);
              }}
              addClass={classes['remove-row']}
            />
          )}
          <Input
            type={'text'}
            value={v}
            onChange={(newVal) => {
              let newArr = [...val];
              newArr[index] = newVal as string;
              setVal(newArr);
            }}
            fullWidth
            placeholder={'Вариант'}
          />
        </div>
      ))}
      {(!val || val.length < 1 || val[val.length - 1]) && (
        <Button
          className={classes['add-button']}
          onClick={() => setVal([...(val || []), ''])}>
          Добавить вариант
        </Button>
      )}
    </div>
  );
};

const Question: FC<
  QuestionModel & { pollId: number; handleSubmit: any; trigger: any }
> = (props) => {
  const [value, setValue] = useState<QuestionModel>(props);

  useEffect(() => {
    handleSubmit(value);
  }, [value]);

  const { questionId, pollId, handleSubmit, trigger } = props;
  return (
    <div className={classes['question']}>
      <div className={classes['question-data']}>
        <Select
          options={options}
          value={getOption(value.type)}
          onChange={(e) => {
            // @ts-ignore TODO: пофиксить типизацию
            setValue((prev) => {
              return { ...prev, type: String((e as OptionModel).value) };
            });
          }}
        />
        <Input
          type={'text'}
          value={value.title}
          placeholder={'Текст вопроса'}
          onChange={(e) => {
            setValue((prev) => {
              return { ...prev, title: String(e as string) };
            });
          }}
          fullWidth
        />
        {['checkbox', 'radio'].includes(value.type) && (
          <ChoiceController
            value={Object.values(value.addition.choice || [])}
            onChange={(newValue) =>
              setValue((prev) => {
                return {
                  ...prev,
                  addition: {
                    default: '0',
                    choice: { ...newValue },
                  },
                };
              })
            }
          />
        )}
      </div>

      <IconButton
        iconType={'delete'}
        color={'secondary'}
        disabled={false}
        onClick={() => {
          trigger(() => deleteQuestion(pollId, questionId));
        }}
      />
    </div>
  );
};

export default Question;
